module.exports = __webpack_public_path__ + "img/login.f3353d85.svg";